import {Component, Input, OnInit, Output, TemplateRef, EventEmitter} from '@angular/core';
import {ITdoTreeItem} from '../models/i-tdo-tree-item';
import {CdkDragDrop, CdkDragEnter, CdkDragExit} from '@angular/cdk/drag-drop';
import {IoTreeNodeModel} from '../../../../modules/imaging/models/io-tree-node.model';

@Component({
  selector: 'app-tdo-tree-item',
  templateUrl: './tdo-tree-item.component.html',
  styleUrls: ['./tdo-tree-item.component.scss']
})
export class TdoTreeItemComponent implements OnInit {
  @Input() model: IoTreeNodeModel;
  @Input() template: TemplateRef<any>;

  @Output() itemSelected = new EventEmitter<ITdoTreeItem>();
  @Output() itemDrop = new EventEmitter<CdkDragDrop<ITdoTreeItem>>();
  @Output() itemDropped = new EventEmitter<CdkDragDrop<ITdoTreeItem>>();

  isDragEnter = false;

  constructor() { }

  ngOnInit(): void {
  }

  onItemClick(): void {
    this.itemSelected.emit(this.model);
  }

  onItemDoubleClick(): void {
    if (this.model.children && this.model.children.length > 0) {
      this.model.isExpanded = !this.model.isExpanded;
    } else {
      this.model.isExpanded = false;
    }
  }

  onItemSelected(item: ITdoTreeItem): void {
    this.itemSelected.emit(item);
  }

  onItemEntered(event: CdkDragEnter<ITdoTreeItem>, model: ITdoTreeItem): void {
    this.isDragEnter = true;
    model.isExpanded = true;
    for (const mod of model.children) {
      mod.isExpanded = true;
    }
  }

  onItemExited(event: CdkDragExit<ITdoTreeItem>): void {
    this.isDragEnter = false;
  }

  onItemDrop(event: CdkDragDrop<IoTreeNodeModel>): void {
    this.isDragEnter = false;
    this.itemDropped.emit(event);
  }

  onItemDropped($event: CdkDragDrop<ITdoTreeItem>) {
    this.itemDropped.emit($event);
  }
}
